import { render } from "./LogDetail.vue?vue&type=template&id=8bb94de2&scoped=true"
import script from "./LogDetail.vue?vue&type=script&lang=js"
export * from "./LogDetail.vue?vue&type=script&lang=js"

import "./LogDetail.vue?vue&type=style&index=0&id=8bb94de2&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb94de2"]])

export default __exports__